(() => {
  const root = window.Shopify?.routes?.root || '/';
  let pending = false;
  let lastButton;
  const popup = document.createElement('dialog');
  popup.className = 'vocab-cart-popup';
  popup.setAttribute('aria-labelledby', 'vocab-cart-popup-title');
  popup.innerHTML = `<button type="button" class="vocab-cart-popup-close" aria-label="Close">×</button><div class="vocab-cart-popup-check" aria-hidden="true">✓</div><h2 id="vocab-cart-popup-title">Added to your cart</h2><p>Your learning resource is ready in your shopping cart.</p><div class="vocab-cart-popup-actions"><a href="${root}cart">View shopping cart</a><button type="button" data-continue>Continue shopping</button></div>`;
  document.body.append(popup);
  let closingPopup = false;
  const closePopup = () => {
    if (closingPopup || !popup.open) return;
    closingPopup = true;
    popup.classList.add('is-closing');
    const finish = () => {
      popup.close();
      popup.classList.remove('is-closing');
      closingPopup = false;
    };
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) finish();
    else setTimeout(finish, 180);
  };
  popup.addEventListener('cancel', event => { event.preventDefault(); closePopup(); });
  popup.querySelector('[data-continue]').addEventListener('click', closePopup);
  popup.querySelector('.vocab-cart-popup-close').addEventListener('click', closePopup);
  popup.addEventListener('click', event => { if (event.target === popup) closePopup(); });
  popup.addEventListener('close', () => lastButton?.focus());
  const showPopup = (cart, alreadyAdded, button) => {
    document.querySelectorAll('.vsr-cart-count').forEach(el => { el.textContent = cart.item_count; });
    document.querySelectorAll('.vsr-cart-link').forEach(el => el.setAttribute('aria-label', `Shopping bag, ${cart.item_count} ${cart.item_count === 1 ? 'item' : 'items'}`));
    popup.querySelector('h2').textContent = alreadyAdded ? 'Already added to your cart' : 'Added to your cart';
    lastButton = button;
    popup.showModal();
    popup.querySelector('[data-continue]').focus();
  };
  async function request(path, body) {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 15000);
    try {
    const response = await fetch(root + path, {signal: controller.signal, method: body ? 'POST' : 'GET', headers: {'Content-Type': 'application/json', Accept: 'application/json'}, ...(body ? {body: JSON.stringify(body)} : {})});
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || 'Unable to update your cart. Please try again.');
    return data;
    } catch (error) {
      if (error.name === 'AbortError') throw new Error('The request took too long. Please try again to check your cart.');
      throw error;
    } finally { clearTimeout(timeout); }
  }
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !new URL(form.action, location.href).pathname.endsWith('/cart/add')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (pending) return;
    pending = true;
    const button = event.submitter;
    if (button) {
      button.disabled = true;
      button.classList.add('vocab-cart-loading');
      button.setAttribute('aria-busy', 'true');
    }
    let status = form.querySelector('[data-single-cart-status]');
    if (!status) {status = document.createElement('p'); status.dataset.singleCartStatus = ''; status.setAttribute('role', 'alert'); form.append(status);}
    status.textContent = '';
    try {
      const data = new FormData(form);
      const id = data.get('id');
      if (!id) throw new Error('Please choose a product option.');
      const cart = await request('cart.js');
      const alreadyAdded = cart.items.some(item => String(item.variant_id) === String(id));
      if (!alreadyAdded) await request('cart/update.js', {updates: {[id]: 1}});
      const updatedCart = alreadyAdded ? cart : await request('cart.js');
      showPopup(updatedCart, alreadyAdded, button);
    } catch (error) {
      status.textContent = error.message;
    } finally {
      pending = false;
      if (button) {
        button.disabled = false;
        button.classList.remove('vocab-cart-loading');
        button.removeAttribute('aria-busy');
      }
    }
  }, true);
  if (document.querySelector('.vcc-cart')) {
    request('cart.js').then(cart => {
      const updates = Object.fromEntries(cart.items.filter(item => item.quantity > 1).map(item => [item.key, 1]));
      if (Object.keys(updates).length) return request('cart/update.js', {updates}).then(() => location.reload());
    }).catch(() => {});
  }
})();
